import React from 'react';

const Logo = ({ className = "w-12 h-12", showText = true, textSize = "xl" }) => {
  return (
    <div className="flex items-center space-x-3 group">
      <div className="relative">
        <svg
          className={`${className} transition-all duration-300 group-hover:scale-110`}
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#0f172a', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#334155', stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          
          <rect 
            x="5" 
            y="5" 
            width="110" 
            height="110" 
            rx="24" 
            fill="url(#logoGrad)" 
            stroke="#3b82f6"
            strokeWidth="2"
          />
          
          <text
            x="60"
            y="75"
            fontSize="48"
            fontWeight="900"
            fontFamily="Arial, sans-serif"
            fill="#3b82f6"
            textAnchor="middle"
            letterSpacing="-2"
          >
            CRS
          </text>
          
          <line x1="20" y1="30" x2="40" y2="30" stroke="#3b82f6" strokeWidth="3" opacity="0.6" strokeLinecap="round" />
          <line x1="80" y1="30" x2="100" y2="30" stroke="#3b82f6" strokeWidth="3" opacity="0.6" strokeLinecap="round" />
          <circle cx="45" cy="30" r="2.5" fill="#3b82f6" opacity="0.8" />
          <circle cx="75" cy="30" r="2.5" fill="#3b82f6" opacity="0.8" />
        </svg>
      </div>

      {showText && (
        <div className="flex flex-col">
          <h1 className={`text-${textSize} font-bold text-slate-900 leading-tight tracking-tight`}>
            CRS Tech
          </h1>
          <p className="text-xs text-blue-500 font-bold -mt-0.5">Digital Excellence</p>
        </div>
      )}
    </div>
  );
};

export default Logo;